import $ from "jquery";

const init = () => {
    scaleDown();
};

const scaleDown = () => {
    if (!$(".header-logo").length) return;

  window.addEventListener('scroll', function(){
    if (window.scrollY == 0){
        $('.header-logo img').removeClass('scale-down')
    } else {
        $('.header-logo img').addClass('scale-down')
    }
  })
};

try {
  init();
} catch (error) {
  console.log(error);
}
